import { X } from '@phosphor-icons/react';
import styled from 'styled-components';
import type { ReactNode, HTMLAttributes } from 'react';
import { CommonUtility } from '../utility';

const Container = styled.div`
  position: absolute;
  z-index: 20;
  top: 40px;
  background: white;
  padding: 20px;
  width: 60%;
  max-width: 500px;
  height: calc(100vh - 50px);
  border-radius: 10px;
  box-shadow: -2px 0px 15px rgba(57, 57, 72, 0.05);
  border-left: 1px solid ${({ theme }) => theme.colors.box};
  z-index: 999;
  right: 10px;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;

  .header {
    position: sticky;
    z-index: 1;
    top: 0px;
    background-color: ${({ theme }) => theme.colors.white};
    padding-bottom: 5px;
  }

  &.show {
    transform: translateX(0%);
  }

  &.hide {
    transform: translateX(110%);
  }

  &.higher-z-index {
    z-index: 1001;
  }
`;

const CrossButton = styled.div`
  height: 40px;
  width: 40px;
  background: white;
  position: absolute;
  top: 50%;
  left: -39px;
  transform: translateY(-50%);
  border: 1px solid ${({ theme }) => theme.colors.box};
  border-right: none;
  border-radius: 5px 0 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.box};
  }
`;

const DimContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  transition: all 0.3s ease;

  &.hide {
    opacity: 0;
    pointer-events: none;
  }

  &.show {
    opacity: 1;
    pointer-events: all;
  }
`;

const ExtrernalContainer = styled.div`
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  &.hide {
    pointer-events: none;
  }
`;

interface IRightSidebarProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  onClose?: () => void;
  open: boolean;
  closeOnOutsideClick?: boolean;
}

export function RightSidebar({
  children,
  onClose,
  open,
  closeOnOutsideClick = false,
  ...props
}: IRightSidebarProps) {
  if (closeOnOutsideClick) {
    return (
      <ExtrernalContainer className={open ? 'show' : 'hide'}>
        <DimContainer className={open ? 'show' : 'hide'} onClick={onClose} />
        <Container className={`higher-z-index ${open ? 'show' : 'hide'}`} {...props}>
          {CommonUtility.isFunction(onClose) && (
            <CrossButton onClick={onClose}>
              <X size={20} />
            </CrossButton>
          )}
          {children}
        </Container>
      </ExtrernalContainer>
    );
  }

  return (
    <Container className={open ? 'show' : 'hide'} {...props}>
      {CommonUtility.isFunction(onClose) && (
        <CrossButton onClick={onClose}>
          <X size={20} />
        </CrossButton>
      )}
      {children}
    </Container>
  );
}
